import { useEffect, useRef } from 'react';
import { axiosAiq } from 'config';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { handleInterceptorResponseError, handleResponseError } from 'utils/axiosHelper';
import { normalizeSpecialCharacters } from 'utils/utils';

export default function useInterceptors() {
    const { isKeycloakIntegrationEnabled } = useFeatureFlag();
    const interceptors = useRef({ responseInterceptorId: null });

    useEffect(() => {
        // Eject previous interceptor
        if (interceptors.current.responseInterceptorId !== null) {
            axiosAiq.interceptors.response.eject(interceptors.current.responseInterceptorId);
        }

        // Determine response interceptor based on feature flag
        const responseInterceptor = isKeycloakIntegrationEnabled ? handleInterceptorResponseError : handleResponseError;

        // Add new interceptor
        const responseInterceptorId = axiosAiq.interceptors.response.use(
            (response) => {
                // Normalize smart/curly quotes in all API response data to standard
                // ASCII equivalents so fields like company names (e.g. "Gibson's")
                // render correctly across all platforms.
                if (response.data) {
                    response.data = normalizeSpecialCharacters(response.data);
                }
                return response;
            },
            (error) => responseInterceptor(error)
        );

        // Store ID for cleanup
        interceptors.current = { responseInterceptorId: responseInterceptorId };

        // Cleanup on unmount or next run
        return () => {
            axiosAiq.interceptors.response.eject(responseInterceptorId);
            interceptors.current = { responseInterceptorId: null };
        };
    }, [isKeycloakIntegrationEnabled]);
}
